<template>
  <div class="seminar-facet-fi">
    <template v-if="facet.type === 'date'">
      <date-facet-fi
        input-name="seminar-events"
        :date="date"
        :label="facet.name"
        @change="onChange"
      />
    </template>
    <select-fi
      v-else
      :elements="facet.elements"
      :name="facet.name"
      :multiselect="facet.multiselect"
      :open="open"
      large
      @change="onChange"
      @toggle-open="onToggleOpen"
      @close="onClose"
    />
  </div>
</template>

<script setup lang="ts">
import { SelectFi } from 'atoms';
import { onMounted, watch } from 'vue';

import type { DateValue } from '@/components/atoms/datepicker-fi/DatepickerFi.vue';
import DateFacetFi from '@/components/facets/date-facet-fi/DateFacetFi.vue';
import type { GenericFacet, GenericFacetChange } from '@/components/facets/facet-types';

defineOptions({ name: 'SeminarFacetFi' });

const props = withDefaults(
  defineProps<{
    facet: GenericFacet;
    open?: boolean;
    idx?: number | null;
    registerDomElement?: ((element: Element) => void) | null;
    date?: DateValue;
  }>(),
  {
    open: false,
    idx: null,
    registerDomElement: null,
    date: null,
  },
);

const emit = defineEmits<{
  change: [payload: GenericFacetChange];
  close: [];
  'toggle-open': [];
}>();

const registerElement = (idx: number | null) => {
  if (idx === 0 && props.registerDomElement) {
    // NOTE: since we check for idx === 0 this will only happen once and not clash with multiple instances
    const el = document.querySelector('.seminar-facet-fi');
    if (el) props.registerDomElement(el);
  }
};

watch(
  () => props.idx,
  (newValue) => {
    registerElement(newValue);
  },
);

onMounted(() => {
  registerElement(props.idx);
});

const onClose = () => {
  if (props.open) {
    onToggleOpen();
  }
  emit('close');
};

const onToggleOpen = () => {
  emit('toggle-open');
};

const onChange = (payload: any) => {
  emit('change', payload);
};
</script>

<style scoped src="./seminar-facet-fi" />
